// test2068
(2068 && 0);
